import React from 'react';
import './App.css';
import Footer from './components/footer';
import Header from './components/header';
import Home from './components/Home';

function App() {
  return (
    <>
      <div><Header /></div>
      <div><Home /></div>
      <div><Footer /></div>
    </>
  );
}

export default App;
